import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BRAND } from "@/data/site";
import { useT } from "@/i18n/I18nProvider";
import { Reveal } from "./Section";
import { EnquiryForm } from "./EnquiryForm";

export const TalkCta = ({ sourcePage = "cta" }) => {
  const t = useT();
  return (
    <section className="bg-[var(--blue)] text-white" data-testid="talk-cta">
      <div className="container-x py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <Reveal>
            <span className="eyebrow !text-white/80">{t("Let's talk about your care")}</span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-[44px] font-bold leading-[1.12] !text-white">
              {t("Tell us about your needs and")} <span className="text-[var(--sun)]">{t("what matters to you.")}</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-white/85 leading-relaxed max-w-lg">{t("Together, we can explore support that fits your life. There's no obligation — just a friendly conversation.")}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/contact" className="btn btn-coral" data-testid="cta-enquire">{t("Enquire About Support")} <ArrowRight size={16} /></Link>
              <a href={`tel:${BRAND.phone.tel}`} className="btn btn-outline-light" data-testid="cta-phone"><Phone size={16} /> {BRAND.phone.number}</a>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-6">
          <div className="bg-white corner-tr p-7 sm:p-9 text-[var(--ink)]" data-testid="cta-enquiry-card">
            <h3 className="!text-[var(--blue)] text-2xl font-semibold">{t("Quick enquiry")}</h3>
            <p className="text-sm text-[var(--muted)] mt-1 mb-6">{t("We usually respond within one business day.")}</p>
            <EnquiryForm sourcePage={sourcePage} />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
